<template>
  <DiscountPassVerification
    :validation-params="validationParams"
    :show-form-level-error-message="true"
    :disable-submit="!form.selfCert || ageFieldError"
    v-on="$listeners"
  >
    <div
      slot="summary"
      class="info"
    >
      <h2 class="legend">
        Validate Eligibility
      </h2>
      <p>A discounted bike share pass is available to people 62 years old and older.</p>
    </div>
    <template slot="eligibility-fields">
      <Input
        id="birthdate"
        v-model="form.birthDate"
        label="Date of birth"
        hint="(mm/dd/yyyy)"
        inputmode="numeric"
        :error="ageFieldError ? 'This discount is only available to seniors 62 years of age or older.' : undefined"
        required
        type="date"
      />
      <div class="checkbox">
        <input
          id="senior-self-cert"
          v-model="form.selfCert"
          type="checkbox"
          class="checkbox__input"
          required
        >
        <label
          for="senior-self-cert"
          class="checkbox__label"
        >By checking this box, I confirm that I am 62 years old or older. I understand that in the future, I may be asked to provide proof of my age. I agree that if I do not provide proof of my age, my benefits may be terminated from the Reduced Fare program.</label>
      </div>
    </template>
  </DiscountPassVerification>
</template>

<script>
import DiscountPassVerification from '../DiscountPassVerification.vue';
import Input from '../../Input.vue';

export default {
  components: { DiscountPassVerification, Input },
  data() {
    return {
      form: {
        birthDate: '',
        selfCert: false,
      },
      validationParams: {
        validationType: 'self_certify',
      },
    };
  },
  computed: {
    ageFieldError() {
      // TODO: MAKE SURE THIS ONLY SHOWS UP ON BLUR
      const comparisonDate = new Date();
      comparisonDate.setFullYear(new Date().getFullYear() - 62);
      if (new Date(this.form.birthDate) > comparisonDate) {
        return true;
      }
      return false;
    },
  },
};
</script>
